module.exports = __webpack_public_path__ + "static/media/img132.087f08fa.jpg";